 export const fetchRenewals = async () => {
    const res = await fetch('https://hs2api.razamit.pl/renewalsList',{
      method:'POST',
      credentials:'include'
    });
    if (!res.ok) throw new Error('Błąd pobiernia danych przedłużeń');
    return await res.json();
  };

  export const settleRenewals = async (ids = []) => {
      const res = await fetch('https://hs2api.razamit.pl/renewals/settle', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids }),
      });
      if (!res.ok) throw new Error('Nie udało się zapisać rozliczonej pozycji');
      return res.json();
    };


  export const SaveVendorStetmment = async (payload) => {
  try {
    const res = await fetch('https://hs2api.razamit.pl/vendor-settlements', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const msg = await res.text();
      return { success: false, message: msg || 'Błąd zapisu' };
    }

    const data = await res.json();
    return { success: true, data };
  } catch (err) {
    return { success: false, message: err.message };
  }
};
